//@ts-check

class Flags {
    constructor(flags) {
        this._flags = {};

        for (const flag of flags) {
            this._flags[flag] = this._tryGetValue(flag);
        }
    }

    isValid(flag) {
        return this._flags.hasOwnProperty(flag);
    }

    set(flag, value) {
        if (!this._flags.hasOwnProperty(flag)) {
            return false;
        }

        // Save locally
        this._flags[flag] = value;

        // Try to save value
        try {
            localStorage.setItem(`flag_${flag}`, JSON.stringify(value));
        } catch (e) { }

        return true;
    }

    get(flag) {
        if (!this._flags.hasOwnProperty(flag)) {
            return null;
        }

        return this._flags[flag];
    }

    _tryGetValue(flag) {
        try {
            const val = localStorage.getItem(`flag_${flag}`);
            const value = JSON.parse(val);

            return (typeof value === 'boolean' ? value : null);
        } catch (e) { }

        return null;
    }
}

export default new Flags([ 'archive' ]);
